import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

interface ContactModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ContactModal({ open, onClose }: ContactModalProps) {
  // ESC 关闭 + 锁定背景滚动
  useEffect(() => {
    if (!open) return;

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.25 }} className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={onClose} >
          <motion.div initial={{ opacity: 0, scale: 0.92, y: 24 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95, y: 12 }} transition={{ duration: 0.3, ease: 'easeOut' }} className="relative w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl" onClick={(e) => e.stopPropagation()} >
            {/* 关闭按钮 */}
            <button type="button" aria-label="关闭弹窗" onClick={onClose} className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition duration-300 hover:bg-slate-200 hover:text-slate-700" >
              <X className="h-4 w-4" />
            </button>

            <h3 className="text-center text-2xl font-bold text-slate-900">
              联系我们
            </h3>
            <p className="mt-2 text-center text-sm text-slate-500">
              扫码添加微信，获取专属服务
            </p>

            {/* 微信二维码（占位图，请替换为真实二维码） */}
            <img src="/images/qrcode.jpg" alt="微信二维码" className="mx-auto mt-6 h-48 w-48 rounded-xl border border-slate-100 object-contain"
            />

            <p className="mt-5 text-center text-xs text-slate-400">
              或拨打{' '}
              <a href="tel:4009868616" className="font-semibold text-slate-600 transition hover:text-cyan-600" >
                4009 868 616
              </a>{' '}
              咨询
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
